module.exports = __webpack_public_path__ + "static/img/Back-z@2x.142edd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/toefl/Back-z@2x.png
// module id = N89V
// module chunks = 96